import { render } from "./pendamping-list.vue?vue&type=template&id=19217724&scoped=true"
import script from "./pendamping-list.vue?vue&type=script&lang=js"
export * from "./pendamping-list.vue?vue&type=script&lang=js"

import "./pendamping-list.vue?vue&type=style&index=0&id=19217724&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19217724"]])

export default __exports__